export const churches = [
  {
    id: "atlantis-nazarene",
    name: "Atlantis Church of the Nazarene",
    area: "Atlantis, Cape Town",
    pastor: "Rev. Nigel J. Kolkoto",
    address: "43 Berzelia St, Protea Park, Cape Town, 7349",
    sundaySchool: "Sunday at 08:30",
    bibleStudy: "Wednesday at 19:00",
    youthService: "Friday at 18:30",
    facebook: "https://www.facebook.com/Church-of-the-Nazarene-Atlantis",
    tiktok: "https://www.tiktok.com/@churchofthenazareneatl",
    outreach: "NMI, Evangelistic Ministry, Prison Ministry",
    image: require('../assets/Atlantis COTN.jpeg'),
    pastorImage: require('../assets/AtlantisResources/AtlantisPastor.jpeg'),
    pastorBio: "Rev. Nigel J. Kolkoto has served as Senior Pastor of Atlantis Church of the Nazarene for 17 years, leading the congregation with a heart for holiness, evangelism, and community transformation.",
    bioSections: [
      {
        tab: 'Background',
        content: [
          { heading: 'Personal Background', body: 'Rev. Nigel J. Kolkoto was born in Bishop Lavis and raised in Cape Town. His upbringing laid a foundation of faith and community that would shape his character and eventual calling into ministry.' },
          { heading: 'Key Life Experiences', body: 'The experiences of his early life in Cape Town gave him a deep understanding of the communities he now serves. These formative years cultivated in him a pastoral heart and a genuine compassion for people from all walks of life.' },
        ],
      },
      {
        tab: 'Calling',
        content: [
          { heading: 'Spiritual Journey', body: 'Rev. Kolkoto gave his life to Christ in 2000. His journey of faith was shaped by the guidance of Rev. Gene Pretorius and Rev. Matthew Simeon, who mentored him during the early years of his walk with God.' },
          { heading: 'Confirmation of the Call', body: 'He felt called into ministry in 2000. The call was confirmed through his mentors and his growing conviction to serve the local church. That calling has remained the driving force behind 17 years of faithful ministry.' },
        ],
      },
      {
        tab: 'Education',
        content: [
          {
            heading: 'Qualifications',
            list: ['Theology — Nazarene Theological College (NTC)'],
          },
        ],
      },
      {
        tab: 'Ministry',
        content: [
          {
            heading: 'Roles Served',
            list: [
              "Minister's License — Belhar Church of the Nazarene",
              'Pastor — Northpine Church of the Nazarene',
              'Senior Pastor — Atlantis Church of the Nazarene (Current)',
            ],
          },
          { heading: 'Ministry Impact', body: 'Over 17 years of ministry, Rev. Kolkoto has led the Atlantis congregation with a commitment to evangelism, outreach, and community development. Under his leadership, the church has maintained active ministries in NMI, evangelism, and prison ministry.' },
        ],
      },
      {
        tab: 'Vision',
        content: [
          { heading: 'Leadership Style', body: 'Rev. Kolkoto leads by example and through positive influence. His approach to mentoring is grounded in the belief that you walk the journey with others that was once walked with you.' },
          { heading: 'Goals & Trust', body: 'His vision for the future is one of trust — to trust God for the now and to remain ready for wherever He leads. He does not chase a fixed plan but remains open and obedient to the leading of the Holy Spirit.' },
          { heading: 'Life Scripture', body: 'Proverbs 3:5–6 — "Trust in the Lord with all your heart and lean not on your own understanding; in all your ways submit to him, and he will make your paths straight."' },
          { heading: 'Legacy', body: 'Rev. Kolkoto hopes to be remembered as a person who loved God and loved others. His personal motto: "Walk faithfully with God today, not because the path is easy, but because His presence makes every step meaningful."' },
        ],
      },
    ],
    historyPeriods: [
      {
        period: '1976–1981',
        title: 'Establishment',
        content: [
          'The church was established in 1976 by the missionary Rev. Emsly. When Ma Vlotman later relocated to Atlantis, Rev. Emsly spent approximately three months actively ministering and working in the Atlantis area. During this initial phase, church activities were conducted from a private home owned by the Van Zyl couple, who resided in Chandor Street, Atlantis.',
          'After the Van Zyl couple, responsibility for the work was taken over by the Emsly family. However, due to advancing age, the Emslys eventually withdrew from active ministry, and the Stiegleader missionary couple assumed leadership of the church. During their tenure, services were relocated to the home of Ma Vlotman at 14 Meteren Street, Avondale.',
          'Following the departure of the Stiegleader couple, Rev. William Bantom took oversight of the congregation. Sunday morning services continued to be held at the Vlotman residence, and worship gatherings remained there for approximately six years.',
          'The first officially appointed pastor of the church was Rev. Nugent Galant, who served while the congregation was still meeting at the Vlotman home. During this time, the church experienced steady growth, particularly as members of the Church of the Nazarene relocated to Atlantis. In addition, a wayside Sunday school ministry was conducted by Ma Vlotman at Eagles Nest in Dura.',
        ],
      },
      {
        period: '1981 onwards',
        title: 'Expansion and Relocation',
        content: [
          'In 1981, due to the growth of the congregation, the church relocated to a classroom at No. 1 Secondary School, where services were held for approximately three to four years. In 1985, the congregation moved again, this time to Berzelia Primary School. During this period, the church experienced rapid growth.',
          'The congregation continued meeting at Berzelia Primary School until the church building was completed in 1986. A significant milestone in the life of the church occurred in 1988, when the first wedding was conducted in the church building, celebrating the marriage of Ma Vlotman\'s daughter.',
          'Rev. Collip served as the second pastor of the church and was responsible for fencing the church grounds. Over the years, several other pastors have served the congregation, including Rev. Cousins, Rev. Slinger, Rev. Wesso, Rev. Sallies, Rev. Karelse, Rev. Fransuzane, Rev. Ramedies, Rev. Rustin, and Rev. Kolkoto. These names are not recorded in chronological order.',
        ],
      },
    ],
    localPastors: [
      { name: 'Ashley Slinger' },
      { name: 'Bevan Brown' },
      { name: 'Cedrick Arendse' },
      { name: 'Donovan De Villiers' },
      { name: 'Graeme Daniels' },
      { name: 'Hetley Pietersen' },
      { name: 'Ivan Hendricks' },
      { name: 'Jenine Charles' },
      { name: 'Jessica Daniels' },
      { name: 'Martin De Villiers' },
      { name: 'Marvin-Jacob Cornelissen' },
    ],
  },
  {
    id: "belhar-nazarene",
    name: "Belhar Church of the Nazarene",
    area: "Belhar",
    pastor: "Matthew Simeon",
    image: require('../assets/Belhar COTN.jpeg'),
  },
  {
    id: "bethany-nazarene",
    name: "Bethany Church of the Nazarene",
    area: "Cape Town",
    pastor: "Pastor Garvin Arendorf",
    image: require('../assets/BethanyCOTN.jpeg'),
    pastorImage: require('../assets/BethanyResources/BethanyPastor.jpeg'),
    pastorBio: "Pastor Garvin Arendorf serves as Senior Pastor of Bethany Church of the Nazarene alongside his wife Michaela. His journey reflects a commitment to obedience and service — from sensing his calling at 16, to pursuing theological studies 1,400 kilometres from home, to faithfully leading God's people.",
    bioSections: [
      {
        tab: 'Background',
        content: [
          { heading: 'Personal Background', body: 'Pastor Garvin Arendorf was born and raised in Cape Town, Western Cape. He grew up in a Christian home where both of his parents were saved and actively involved in their local church. His upbringing in a Christian environment played an important role in shaping his faith and understanding of serving God.' },
          { heading: 'Key Life Experiences', body: 'His experiences within the local church, particularly through youth ministry, became significant in his journey and eventually contributed to his calling into ministry. One of the key experiences that shaped him was responding to God\'s call at a young age and being willing to step away from what was familiar in order to pursue theological training and ministry. Before pursuing theological studies, he had also been pursuing a trade in fitting and machining.' },
        ],
      },
      {
        tab: 'Calling',
        content: [
          { heading: 'Spiritual Journey', body: 'Pastor Garvin grew up in a Christian home and became actively involved in his local church. At the age of 16, while pursuing a trade in fitting and machining, he felt God\'s call into ministry. He began serving faithfully in the youth ministry of his local church and eventually became the youth president. Through his involvement in the church and his growing desire to serve God\'s people, his calling into ministry became increasingly evident.' },
          { heading: 'Confirmation of the Call', body: 'A significant confirmation of his calling came during his theological studies, when God reminded him through a vision: "First do My will." These words became a defining principle in his journey of faith and ministry, reminding him to place God\'s will above his own plans and desires.' },
        ],
      },
      {
        tab: 'Education',
        content: [
          {
            heading: 'Qualifications',
            list: [
              'Theology — Nazarene Theological College (NTC), accepted 2009',
            ],
          },
          { heading: 'Commitment to Training', body: 'In 2009, Pastor Garvin was accepted into NTC to study theology. This required him to travel approximately 1,400 kilometres from home in order to pursue his theological education. His studies equipped him for pastoral ministry and prepared him to serve in various ministry roles following their completion.' },
        ],
      },
      {
        tab: 'Ministry',
        content: [
          {
            heading: 'Roles Served',
            list: [
              'Youth Ministry Member — Local church',
              'Youth President — Local church',
              'Youth Pastor — Western Cape District',
              'Associate Pastor — Western Cape District',
              'Senior Pastor — Bethany Church of the Nazarene (Current)',
            ],
          },
          { heading: 'Current Role', body: 'Together with his wife Michaela, Pastor Garvin answered God\'s call to serve as Senior Pastor of Bethany Church of the Nazarene. He is passionate about serving God\'s people and contributing to the growth and strengthening of the local church.' },
          { heading: 'Ministry Philosophy', body: 'He believes that ministry extends beyond preaching from the pulpit and includes serving, leading, encouraging and caring for people. His ministry journey has included working with young people as a youth pastor, serving as an associate pastor, and now providing pastoral leadership at Bethany. He views ministry as an opportunity to invest in people\'s lives, encourage them in their faith and help strengthen the Church.' },
          { heading: 'Stewardship & Responsibility', body: 'His experience working as a stock controller at a car dealership shaped his perspective on responsibility and stewardship. He draws a direct connection between that role and his pastoral calling: "Just as I keep watch over what is entrusted to me, God has called me to keep watch over His flock."' },
        ],
      },
      {
        tab: 'Values',
        content: [
          { heading: 'Core Value', body: 'A central value in Pastor Garvin\'s ministry is obedience to God\'s will. The words "First do My will," received during a vision while studying theology, have remained an important and defining principle throughout his entire journey.' },
          { heading: 'Leadership Style', body: 'He believes that pastoral leadership involves more than standing behind a pulpit. His approach to ministry includes serving, leading, encouraging and caring for people — reflecting a servant-hearted model of leadership.' },
          { heading: 'Personal Life', body: 'Pastor Garvin is married to Michaela, who serves alongside him in ministry. Their shared journey of responding to God\'s call has led them to serve together at Bethany Church of the Nazarene. Outside of ministry, Pastor Garvin enjoys sports and has a great passion for cars. He also has experience working as a stock controller at a car dealership.' },
        ],
      },
      {
        tab: 'Vision',
        content: [
          { heading: 'Vision for the Church', body: 'Pastor Garvin has a strong desire to see God\'s Church grow and to see more people come to know Christ. His vision is rooted in remaining faithful to God\'s direction and seeing the vision God has given him fulfilled. His desire is that God would bless everything he puts his mind and hands to and use his life and ministry to grow His Church.' },
          { heading: 'Life Scripture', body: 'Habakkuk 2:2 — "Write the vision, and make it plain upon tables, that he may run that readeth it." His favourite book of the Bible is Habakkuk, particularly chapter 2, which reminds him to trust God\'s timing and remain faithful to the vision God has given him.' },
          { heading: 'Motto', body: '"First do My will." — These words, received during a vision while studying theology, have remained the defining motto and guiding principle of his life and ministry.' },
        ],
      },
    ],
  },
  {
    id: "bishop-lavis-nazarene",
    name: "Bishop Lavis Church of the Nazarene",
    area: "Bishop Lavis",
    pastor: "Jeremiah Siljeur",
  },
  {
    id: "bluedowns-nazarene",
    name: "Bluedowns Church of the Nazarene",
    area: "Blue Downs",
    pastor: "Rev. Harold W. Jansen",
    image: require('../assets/BluedownsResources/BluedownsCOTN.jpeg'),
    pastorImage: require('../assets/BluedownsResources/BludownsPastor.jpeg'),
    pastorBio: "Rev. Harold W. Jansen has served as Senior Pastor of Blue Downs Church of the Nazarene since 2005. He is a servant leader committed to building a community where people are free to worship and experience the love of Christ.",
    bioSections: [
      {
        tab: 'Background',
        content: [
          { heading: 'Personal Background', body: 'Rev. Harold W. Jansen was born and raised in Bridgetown. He is one of eleven children and accepted the Lord at a cottage meeting at the age of 23. He married Bianca Matthews on 30 September 2000 and they have four daughters: Tamar, twins Keziah and Keren, and their youngest Leah.' },
          { heading: 'Key Life Experiences', body: 'His conversion was a turnaround experience in his life. His marriage shaped and changed him deeply, as did the birth of his first daughter. These milestones continue to anchor his faith and ministry.' },
        ],
      },
      {
        tab: 'Calling',
        content: [
          { heading: 'Spiritual Journey', body: 'Rev. Jansen gave his life to Christ in 1991, accepting Jesus as Lord and Saviour. He felt called into ministry in 1992 and registered at NTC College in 1995. After returning home due to unforeseen circumstances, the call came again in his first year of marriage. He returned to NTC in 2002 and graduated as valedictorian.' },
          { heading: 'Confirmation of the Call', body: "God's answers to various prayers confirmed his calling. Further confirmation came through fellow believers at Sunnyside Church of the Nazarene." },
        ],
      },
      {
        tab: 'Education',
        content: [
          {
            heading: 'Qualifications',
            list: [
              'Certificate in Engineering — NTC 1, NTC 2, NTC 3 (Trade Tested 1990)',
              'Diploma in Theology — Nazarene Theological College, Muldersdrift (2004)',
              'BA Honours in Theology — University of the Western Cape (2022)',
            ],
          },
        ],
      },
      {
        tab: 'Ministry',
        content: [
          {
            heading: 'Roles Served',
            list: [
              'SRC Representative — Nazarene Theological College',
              'First Pastorate — Factreton Church of the Nazarene',
              'MET Lecturer — NTC Western Cape Satellite Centre',
              'Member of the District Board of Ministry (2021–2025)',
              'Senior Pastor — Blue Downs Church of the Nazarene (Current)',
            ],
          },
          { heading: 'Ministry Impact', body: 'Rev. Jansen has made a significant impact through teaching MET classes that prepared students for ministry at the NTC Western Cape Satellite Centre. He has also served as Vice Chairperson and Chairperson at Excelsior High School, extending his influence into the broader community.' },
        ],
      },
      {
        tab: 'Vision',
        content: [
          { heading: 'Leadership Style', body: 'Rev. Jansen leads by example with servant leadership, humility, and understanding. His key scripture is John 13:34 — "A new commandment I give you, that you love one another as I have loved you."' },
          { heading: 'Mentoring', body: 'Mentoring in the pastorate is an imperative to Rev. Jansen, because it works both ways — it challenges the mentor as he imparts valuable experience and knowledge, while encouraging and offering stability to the mentee.' },
          { heading: 'Vision for the Church', body: 'To build a place where people are free to worship the Lord in communion with one another, experience the love of Christ through believers, and where Jesus Christ is exalted among them.' },
          { heading: 'Goals', body: 'To enter full-time ministry within the next five years. His life scripture is Psalm 90:12 — "Teach me to number my days, that I may gain a heart of wisdom."' },
          { heading: 'Legacy', body: 'To be found faithful to Christ and His Church. His motto: "Live every day to your full potential — live a life of no regret." And a fun fact: he is still very much in love with his wife.' },
        ],
      },
    ],
  },
  {
    id: "bonteheuwel-nazarene",
    name: "Bonteheuwel Church of the Nazarene",
    area: "Bonteheuwel",
    pastor: "Donovan Ramedies",
    image: require('../assets/BonteheuwelCOTN.jpeg'),
    address: "210 Bonteheuwel Ave, Bonteheuwel, 7764",
    sundaySchool: "Sunday at 09:00",
    bibleStudy: "Wednesday at 19:00",
    youthService: "Friday at 18:00",
    outreach: "Cottage meetings and open air service; house visitation",
    history: "The church was started in 1968 and the focus has always been growing from outside in. Youth, Sunday School and Missionary ministries have always been a priority.",
    pastorBio: "The Pastor is an Elder in the church for 44 years, currently completing his Honours in Theology.",
  },
  {
    id: "capricorn-nazarene",
    name: "Capricorn Church of the Nazarene",
    area: "Capricorn",
    pastor: "Bernard Daniels",
    image: require('../assets/CapricornCOTN.jpeg'),
    address: "106 Harmony Road, Capricorn",
    sundaySchool: "Sunday at 15:00",
    youthService: "Friday at 19:00",
    outreach: "Cottage meetings, Wayside Sunday School",
    history: "Church was organized in 2007 by the then DS Patrick Paulse, pastored by Pastor Bernard Daniels. Originally located at Faranaza's Edu-Care Center, Vrygrond Avenue. The church currently has its own property at 106 Harmony Road.",
    pastorBio: "Rev. Bernard Daniels — Ordained Elder. Wife: Audrey Daniels. Two adult children: Darian and Chanelle. Worked for the City of Cape Town (retired). Ministered at Capricorn while maintaining secular work. Active in all spheres of ministry and committed to the work of the Lord.",
  },
  {
    id: "chatsworth-nazarene",
    name: "Chatsworth Church of the Nazarene",
    area: "Cape Town",
    pastor: "Ivan Hendricks",
  },
  {
    id: "covenant-nazarene",
    name: "Covenant Church of the Nazarene",
    area: "Cape Town",
    address: "10 Chichester Rd, Claremont, Cape Town, 7780",
    pastor: "Bob Naidoo",
    image: require('../assets/CovenantCOTN.jpeg'),
    pastorImage: require('../assets/CovenantResources/CovenantPastor.jpeg'),
    pastorTitle: 'Senior Pastor',
    pastorSummary: 'Rev. Bob Naidoo returned to Covenant Church Claremont in April 2020. With 30 years of full-time pastoral ministry in the Church of the Nazarene, his deepest passion remains making Christlike disciples and financial growth.',
    pastorBio: 'In April 2020, Reverend Bob Naidoo returned to Covenant Church Claremont. With 30 years of full-time pastoral ministry in the Church of the Nazarene—including 14 years at Green Pastures—his deepest passion remains making Christlike disciples and financial growth. Rev. Naidoo\'s life and ministry are anchored in his favourite scripture, James 3:13–18. He is happily married to Rosalind, and together they celebrate their growing family: their son Irwin, daughter-in-law Samantha, and grandson Elijah.',
  },
  {
    id: "delft-nazarene",
    name: "Delft Church of the Nazarene",
    area: "Delft",
    pastor: "Ferdie Hanekam",
    image: require('../assets/DelftCOTN.jpeg'),
  },
  {
    id: "eastridge-nazarene",
    name: "Eastridge Church of the Nazarene",
    area: "Mitchells Plain",
    pastor: "Howard Mitchell",
    image: require('../assets/EastridgeCOTN.jpeg'),
    address: "3 Lohengrin, Eastridge, Mitchells Plain",
    sundaySchool: "Sunday at 09:00",
    facebook: "https://www.facebook.com/eastridgechurchofthenazarine",
    history: "Eastridge Church of the Nazarene has been an established congregation since 1983, originally founded as Beacon Valley Church of the Nazarene. In 2005, the congregation purchased property in Eastridge and was renamed accordingly. Rooted in the Wesleyan-Holiness movement, the church emphasises salvation, entire sanctification, and a life of holiness.",
    pastorBio: "Assistant Pastor at Bethany COTN 2008–2012; Senior Pastor at Eastridge COTN from 2013 to present.",
  },
  {
    id: "ebenezer-nazarene",
    name: "Ebenezer Church of the Nazarene",
    area: "Cape Town",
    pastor: "Nugent Gallant",
    image: require('../assets/EbenezerCOTN.jpeg'),
  },
  {
    id: "elshaddai-nazarene",
    name: "El Shaddai Church of the Nazarene",
    area: "Cape Town",
    pastor: "Eldrid Smith",
    address: "3 Sonnemeisie Str, De Kuilen, Kuils River",
  },
  {
    id: "factreton-nazarene",
    name: "Factreton Church of the Nazarene",
    area: "Factreton",
    pastor: "Reginald Subjee",
    image: require('../assets/FactretonCOTN.jpeg'),
    pastorImage: require('../assets/FactretonResources/FactretonPastor.jpeg'),
  },
  {
    id: "grace-nazarene",
    name: "Grace Family Church of the Nazarene",
    area: "Tafelsig, Cape Town",
    pastor: "William Bantom",
    image: require('../assets/GraceCOTN.jpeg'),
    address: "1 Oranjekloof, Tafelsig",
    sundaySchool: "Sunday at 09:00",
    youthService: "Friday at 19:00",
    outreach: "NMI",
    pastorBio: "Senior Pastor: Rev. William David Bantom. Associate Pastor: Rev. Garvin Arendorf.",
  },
  {
    id: "greenpastures-nazarene",
    name: "Green Pastures Church of the Nazarene",
    area: "Cape Town",
    pastor: "Fluen Martin",
    image: require('../assets/GreenpasturesCOTN.jpeg'),
  },
  {
    id: "groenheuwel-nazarene",
    name: "Groenheuwel Church of the Nazarene",
    area: "Paarl",
    pastor: "Rev. Esra Regean Raymond Maralack",
    address: "4 Calendula Street, Groenheuwel, Paarl, 7646",
    sundaySchool: "Sunday at 09:00",
    youthService: "Fridays at 18:00",
    outreach: "Open Airs, Door to door, Wayside Sunday School at 15:00",
    history: "The church started on the porch of Sister Heffenaar 26 years ago, then moved to Brother Jan's yard in a Wendy house in 2001, which remains the place of worship. Members came and left over the years, but the core of the Groenheuwel ministry stayed intact because prayer is the foundation.",
    pastorBio: "Rev. Esra Regean Raymond Maralack has served as Senior Pastor of Groenheuwel Church of the Nazarene since 2017, with 10 years of full-time ministry. His vision is to build a house of the Lord where every member, young and old, becomes responsible and steadfast in Jesus Christ.",
    bioSections: [
      {
        tab: 'Background',
        content: [
          { heading: 'Personal Background', body: 'Rev. Esra Regean Raymond Maralack was born and raised in Paarl, Western Cape. He was born into a family of seven brothers and three sisters, and is proud to be the son of the first Nazarene member in the Boland — a co-pioneer alongside the Winegardt pastoral couple.' },
          { heading: 'Early Life & Faith', body: 'He was part of the Church of the Nazarene until the age of seven, then grew up in the Baptist Church until he was 17 turning 18. He attended William Lloyd Primary School and Paulus Joubert Secondary School, completing Grade 12 in 1988. From Grade 8 to Grade 12 he served as class leader and was captain of the school volleyball team. He later moved to Knysna after he was not accepted into the Baptist Seminary because he did not meet the minimum age requirement of 21.' },
          { heading: 'Career Milestone', body: 'In 1998, he became the first and youngest Provincial Ambulance Chief Officer of the Knysna Provincial Ambulance Service in the Western Cape — a significant achievement in an environment where he felt viewed as an outsider for not being born in Knysna.' },
          { heading: 'Key Life Experiences', body: "Growing up in a resilient, spiritually grounded family instilled in him sacrifice, hard work, and perseverance. His father instilled the belief that nothing is impossible and that he should never say 'I cannot.' His efforts to be selected among the best in the Boland Provincial Sports team further shaped his drive for excellence. After returning to the Nazarene denomination, he also encountered what he describes as a false or misguided perception that people from the Cape Town metropolitan area were superior to those from rural areas such as Paarl — a perception he had to navigate throughout much of his adult life in Emergency Medical Services. These experiences shaped his resilience, work ethic, and determination to continue serving despite challenges." },
        ],
      },
      {
        tab: 'Calling',
        content: [
          { heading: 'Spiritual Journey', body: "Rev. Maralack gave his life to Christ at the age of 12. He was born and raised in a household where God was served. Like many teenagers, he went astray, feeling he had not been fully equipped to withstand the tactics of Satan. Through God's grace, he experienced restoration and became more resilient in pursuing his calling." },
          { heading: 'The Call to Ministry', body: 'He never experienced his calling as something that began at a particular moment. Rather, he believes he was born with the call to ministry — it has always been part of his life and identity. Ministry also has deep roots in his family, with his grandfather, brother, many uncles, cousins, and nieces serving as pastors.' },
          { heading: 'Confirmation of the Call', body: "His calling was confirmed while listening to a sermon preached by his late uncle. Following the sermon, he went to speak with his uncle about what he had experienced — including what he described as a touch on his shoulders. From that day, he said yes to the calling, and he continues to say yes to God." },
        ],
      },
      {
        tab: 'Education',
        content: [
          {
            heading: 'Qualifications',
            list: [
              'Diploma in Theology — Nazarene Theological Seminary',
              'Diploma in Emergency Care',
              'Certificate in Disaster Management Concepts',
              'Certificate in Financial Management',
            ],
          },
          {
            heading: 'Additional Training',
            list: [
              'Emergency Care Practitioner Training',
              'Psychosocial Dynamics of Disasters — World Health Organization (WHO)',
              'Financial Management — SCOPA',
              'Disciplinary Code and Procedures',
            ],
          },
        ],
      },
      {
        tab: 'Ministry',
        content: [
          {
            heading: 'Roles Served',
            list: [
              "Associate Pastor (Worship Team & Men's Ministry) — Matroosfontein Family Church of the Nazarene",
              'Senior Pastor — Groenheuwel Church of the Nazarene (Current)',
            ],
          },
          { heading: 'Responsibilities', body: 'His role involves leading the congregation, teaching and preaching the Word of God, developing leaders, providing spiritual guidance, and helping members grow in their faith and Christian walk.' },
          { heading: 'Key Milestones', body: 'One of his most significant milestones has been developing followers into leaders — witnessing those under his care preach and teach the Bible soundly, and seeing families once trapped in despair experience spiritual growth. He also finds deep fulfilment in seeing young leaders passionately lead the youth and Sunday School ministries, teaching lessons they once resisted.' },
          {
            heading: 'Ministry Initiatives',
            list: [
              'Mental development',
              'Spiritual training',
              'Discovering and developing self-worth',
              'Evangelism',
              'Community outreach',
            ],
          },
          { heading: 'Community Impact', body: 'Under his leadership, Groenheuwel Church of the Nazarene has grown from an unknown congregation to a recognised presence in the community. The church has attracted families from outside the Nazarene denomination, with parents sending their children to participate in Sunday School and youth activities.' },
        ],
      },
      {
        tab: 'Values',
        content: [
          {
            heading: 'Core Values',
            list: [
              'Self-respect',
              'A strong work ethic',
              'Consistency',
              'Loving others regardless of circumstances',
            ],
          },
          { heading: 'Leadership Style', body: 'He describes his leadership style as Word-based, strict but understanding, and grounded in love and compassion, with very little room for compromise. His approach places importance on biblical principles while recognising the need to lead people with understanding and care.' },
          { heading: 'Mentoring Approach', body: 'The most important principle in his teaching ministry is that Jesus Christ must always be the priority. He seeks to guide people towards a Christ-centred life, ensuring that their spiritual growth and service are grounded in their relationship with Jesus.' },
          { heading: 'Personal Life', body: 'Rev. Maralack is married and has children. He tries to spend time with his family, though he acknowledges that balancing family life and ministry is not always easy while the church is still being built. He enjoys spending time in nature and going on scenic drives. He also enjoys hugging people and making children feel important and valued, and dislikes being honoured simply because of his title — preferring genuine relationships and meaningful service over recognition based on position.' },
        ],
      },
      {
        tab: 'Vision',
        content: [
          { heading: 'Vision for the Church', body: 'To build a house of the Lord where every member, young and old, becomes responsible and steadfast in Jesus Christ, lacking nothing in their spiritual walk. He desires to see a congregation firmly established in Christ and committed to continued spiritual growth.' },
          {
            heading: 'Goals for the Next 3–5 Years',
            list: [
              'Developing young people to reach Paarl for Jesus Christ',
              "Growing the Children's Ministry to reach as many Sunday School children as possible",
            ],
          },
          { heading: 'Life Scripture', body: 'Romans 8:28 — "And we know that in all things God works for the good of those who love him, who have been called according to his purpose."' },
          { heading: 'Advice to Others', body: 'Never quit if you know that something is from God. No matter how difficult the journey becomes, remain faithful and continue pursuing what God has called you to do.' },
          { heading: 'Legacy', body: "Rev. Maralack hopes to be remembered as someone who gave his all to God and to the ministry, without taking half measures — reflecting wholehearted commitment, perseverance, and faithfulness to his calling. His motto: 'I cannot do this alone, but I'm not going to beg anyone to pull the load through the drift; God will give me the strength.'" },
        ],
      },
    ],
  },
  {
    id: "holinessevangelism-nazarene",
    name: "Holiness Evangelism Church of the Nazarene",
    area: "Cape Town",
    pastor: "Patrick Mckenzie",
  },
  {
    id: "hopecity-nazarene",
    name: "Hope City Church of the Nazarene",
    area: "Cape Town",
    pastor: "Yvonne Slinger",
  },
  {
    id: "immanuel-nazarene",
    name: "Immanuel Church of the Nazarene",
    area: "Cape Town",
    pastor: "Cecil Kannemeyer",
    image: require('../assets/ImmanuelCOTN.jpeg'),
  },
  {
    id: "khayelitsha-nazarene",
    name: "Khayelitsha Church of the Nazarene",
    area: "Khayelitsha",
    address: "4 Ncipisa Street, Town II, Khayelitsha, Cape Town",
    pastor: "Marlene Karelse",
    image: require('../assets/KhayelitshaCOTN.jpeg'),
  },
  {
    id: "leiden-nazarene",
    name: "Leiden Church of the Nazarene",
    area: "Delft",
    pastor: "John Samuels",
  },
  {
    id: "manenberg-nazarene",
    name: "Manenberg Church of the Nazarene",
    area: "Manenberg",
    image: require('../assets/ManenbergCOTN.jpeg'),
    pastor: "Nathan Valensky",
    address: "35C Tugela Road, Manenberg",
    youthService: "Friday at 19:00",
    outreach: "Open Air, bread drive",
    pastorBio: "Rev. Nathan Valensky is the senior pastor of Manenberg COTN. Prior to coming to Manenberg COTN in 2024, he served as senior pastor at Victory COTN for 7 years. He has a deep passion for the church and the preaching of God's word and loves seeing people come to know Jesus. Nathan is married to Thalia, who is also the worship leader. They have two children, Jordan and Jamie-Lee.",
  },
  {
    id: "matroosfontein-nazarene",
    name: "Matroosfontein Church of the Nazarene",
    area: "Matroosfontein",
    pastor: "Wayne Davids",
    image: require('../assets/MatroosfonteinCOTN.jpeg'),
    address: "26 Civic Way, Matroosfontein",
    sundaySchool: "Sunday at 08:30",
    youthService: "Friday at 19:00",
    facebook: "https://www.facebook.com/MatroosfonteinChurchOfTheNazarene",
    outreach: "Open air services, house visitations, soup kitchen, active youth ministry outreach, fitness class for 60+ on Tuesdays at 10:00",
    history: "A church on the move striving to reach the lost for Christ. The church celebrates 60 years in existence this year, to God be the Glory. (John 13:35)",
    pastorImage: require('../assets/MatroosfonteinResources/MatroosfonteinPastor.jpeg'),
  },
  {
    id: "montagu-nazarene",
    name: "Montagu Church of the Nazarene",
    area: "Montagu",
    pastor: "Melwyn Smith",
  },
  {
    id: "neworleans-nazarene",
    name: "New Orleans Church of the Nazarene",
    area: "Mitchells Plain",
    pastor: "Gail Arendse",
  },
  {
    id: "northpine-nazarene",
    name: "Northpine Church of the Nazarene",
    area: "Brackenfell",
    pastor: "Trevor Rich",
    image: require('../assets/NorthpineCOTN.jpeg'),
    address: "21, 12th Ave, Belmont Park, 7570",
    sundaySchool: "Sunday at 09:30",
    outreach: "Campaign, outreach Bible studies in various homes, soup kitchen",
    history: "Northpine Church was started in 1992 by laypersons from Matroosfontein CotN under the leadership of Bro Cliffy September. Three pastors later — Rev. W. Snell, Rev. N. Kolkoto, and Rev. Trevor Rich — the church was finally able to buy and obtain property for a church building. Glory to God!",
    pastorBio: "Senior Pastor: Rev. Trevor Rich, ordained 2005 (in ministry as a pastor since 2001 at Brooklyn CotN). Associate Minister: Dr/Rev. Edna Rich, ordained 2008. Has 3 adult children and one adult granddaughter.",
  },
  {
    id: "overcome-nazarene",
    name: "Overcome Church of the Nazarene",
    area: "Cape Town",
    pastor: "Reginald Subjee",
    address: "St Patrick Avenue",
    sundaySchool: "Sunday at 09:00",
    youthService: "Friday at 17:00",
    pastorImage: require('../assets/DS.jpeg'),
  },
  {
    id: "paarl-nazarene",
    name: "Paarl Church of the Nazarene",
    area: "Paarl",
    pastor: "Pastor Vincent Jonkers",
    image: require('../assets/PaarlCOTN.jpeg'),
    address: "Cnr Pittesporum & Evans Street, Klein Nederberg, Paarl",
    pastorImage: require('../assets/PaarlResources/PaarlPastor.jpeg'),
    pastorBio: "Pastor Vincent Jonkers and his wife Denise are a pastoral couple with 13 years of faithful service to the Paarl Church of the Nazarene, investing in church leadership development and community transformation.",
    bioSections: [
      {
        tab: 'Background',
        content: [
          { heading: 'Personal Background', body: 'Pastor Vincent Jonkers was born in Elsies River and raised in Mitchell\'s Plain. He and his wife Denise are a pastoral couple with 13 years of faithful service to the Paarl Church of the Nazarene, investing in church leadership development and community transformation. He also served as assistant pastor at El Shaddai Church of the Nazarene for 6 years before taking the assignment in Paarl.' },
          { heading: 'Key Life Experiences', body: 'Even though he accepted the calling, because of his very successful business he postponed going to NTC. God then allowed him to lose everything — he was stripped and had to return like the prodigal son, asking for forgiveness. He recommitted his life and calling, and today people see who he is without knowing the full story behind his journey.' },
        ],
      },
      {
        tab: 'Calling',
        content: [
          { heading: 'Spiritual Journey', body: 'Pastor Jonkers gave his life to Christ in 1981. He always wanted to be involved in youth ministry, and this desire became the foundation of his sense of calling.' },
          { heading: 'Confirmation of the Call', body: 'He wanted God to give him confirmation of his calling. In 1987, at a family district camp at the district grounds, Rev. L. B. Smith preached a message titled "How Shall I Send and How Will You Go" from Isaiah 6:8. That message was for him the confirmation of his calling into ministry.' },
        ],
      },
      {
        tab: 'Education',
        content: [
          {
            heading: 'Qualifications',
            list: [
              'Pastoral Course of Studies',
              'Graduated from Nazarene Theological College (NTC), Johannesburg, South Africa',
              'Completed Facilitator\'s Course — Veritas SA',
            ],
          },
        ],
      },
      {
        tab: 'Ministry',
        content: [
          {
            heading: 'Roles Served',
            list: [
              'Assistant Pastor (6 years) — El Shaddai Church of the Nazarene',
              'Western Cape District NYI Youth Leader',
              'Serving the NMI and NDI on district level as youth leader',
              'Member of the District Board of Ministerial Credentials',
              'Delegate representing the Western Cape District at the Nazarene General Assembly',
              'NTC Facilitator in the Boland',
              'Senior Pastor — Paarl Church of the Nazarene (Current)',
            ],
          },
          { heading: 'Current Responsibilities', body: 'He serves as Senior Pastor of the Paarl Church of the Nazarene and as an NTC Facilitator in the Boland, equipping and preparing students for ministry in the region.' },
          {
            heading: 'Ministry Impact',
            list: [
              'Men\'s Ministry — Western Cape District',
              'The Big Brother Program: an initiative for the Men\'s Ministry that helps struggling Men\'s Ministries to improve and grow',
              'Children\'s Church for ECD at Happy Pikinini\'s Educare — bringing the church into the community through early childhood development',
            ],
          },
          { heading: 'Mentoring', body: 'He is currently mentoring and assisting 3 local licensed ministers in their preparation for ministry.' },
        ],
      },
      {
        tab: 'Values',
        content: [
          {
            heading: 'Core Values',
            list: [
              'Biblical Integrity — Teaching and living by the truths of God\'s Word without compromise',
              'Servant Humility — Following Christ\'s example by putting the needs of the flock above personal ego or recognition',
              'Deep Compassion — Loving people genuinely with empathy, active listening and care for the hurting',
              'Relational Unity — Fostering a church culture of grace, forgiveness and peace while actively rejecting gossip and division',
            ],
          },
          { heading: 'Leadership Style', body: 'His leadership style is centred on teaching and the development of Christlike leaders for the Kingdom of God.' },
          { heading: 'Personal Life', body: 'Pastor Jonkers is married to Denise Jonkers. Together they have 5 children and 6 grandchildren. His ministry is important to him, and so is his family. They go camping at least once a year as a family to refresh family bonds, celebrate family achievements and support one another. Outside of ministry, he enjoys hobby fish keeping and outdoor life.' },
        ],
      },
      {
        tab: 'Vision',
        content: [
          {
            heading: 'Vision for the Church',
            list: [
              'Exalting Christ — Creating an environment where God is worshipped sincerely and lives are transformed by the Gospel',
              'Equipping the Saints — Preparing everyday believers for active ministry, moving people from passive attendance to purposeful service',
              'Reaching the Lost — Engaging the community and the world with a message of hope, healing and redemption in Jesus Christ',
            ],
          },
          {
            heading: 'Personal Goals for the Next 3–5 Years',
            list: [
              'Spiritual Vitality — Maintaining personal prayer, scripture study and communication with God',
              'Effective Preaching and Teaching — Preparing clear and biblically sound messages that feed the congregation and apply to daily life',
              'Leadership Development — Identifying, mentoring and empowering new leaders and volunteers to share the ministry workload',
              'Personal and Family Health — Guarding against burnout by prioritising physical wellbeing, rest and quality time with family and spouse',
            ],
          },
          {
            heading: 'Church Goals for the Next 3–5 Years',
            list: [
              'Adding 6 new families to the congregation',
              '10% annual increase in finances',
            ],
          },
          { heading: 'Life Scripture', body: 'Psalm 32:7 — "You are my hiding place; you will protect me from trouble and surround me with songs of deliverance."' },
          { heading: 'Advice to Others', body: 'Do or give your best now, because God honours effort.' },
          { heading: 'Legacy', body: 'A person who lived his life to the fullest in being faithful and honouring God for the opportunity to be the best servant, husband and father that he could be — being a blessing to his children and children\'s children, that the blessings of God would be theirs for generations to come.' },
          { heading: 'Fun Fact', body: 'He lives for the moment. He aims to make everyone smile and feel good about themselves. His outlook: "Don\'t worry, be happy — God is in control."' },
        ],
      },
    ],
  },
  {
    id: "parkwood-nazarene",
    name: "Parkwood Church of the Nazarene",
    area: "Parkwood",
    pastor: "Marthinus Martin",
    image: require('../assets/ParkwoodCOTN.jpeg'),
    address: "78 Acacia Street, Parkwood, 7800",
  },
  {
    id: "portlands-nazarene",
    name: "Portlands Church of the Nazarene",
    area: "Mitchells Plain",
    pastor: "Gene Pretorius",
    image: require('../assets/PortlandsCOTN.jpeg'),
    address: "84 Silversands Street, Portlands, Mitchells Plain",
    sundaySchool: "Sunday at 08:45",
    youthService: "Friday at 19:30",
  },
  {
    id: "restoration-nazarene",
    name: "Restoration Church of the Nazarene",
    area: "Heideveld",
    pastor: "Ps Daniel Henry Carelse",
    address: "44 Hex Crescent, Manenberg, 7767",
    sundaySchool: "Sunday at 09:00",
    youthService: "Fridays at 18:00",
    facebook: "https://www.facebook.com/share/179wSCQWHT/?mibextid=wwXIfr",
    outreach: "Open airs, prayer walks, cottage meetings, soup kitchen",
    pastorImage: require('../assets/RestorationResources/RestorationPastor.jpeg'),
    pastorBio: "Ps Daniel Henry Carelse serves as Senior Pastor of Restoration Church of the Nazarene in Heideveld. He has been serving in full-time ministry for five years, dedicated to the spiritual growth, guidance and development of the congregation and the wider community. Before entering full-time ministry, he spent 36 years working at TFG, serving until his retirement in 2026.",
    image: require('../assets/Restoration COTN.jpeg'),
    bioSections: [
      {
        tab: 'Background',
        content: [
          { heading: 'Personal Background', body: 'Ps Daniel Henry Carelse was born and raised in Kalksteenfontein. He attended Kalksteenfontein Primary School and later Arcadia Senior Secondary School in Bonteheuwel. Growing up in a family of nine children, he experienced the joys and challenges of life in a large household. As the youngest of three brothers, he fondly remembers a close-knit family environment filled with laughter, jokes and shared experiences. His family lived in a two-bedroom home, where his parents raised their children with discipline, fairness and love.' },
          { heading: 'Family Influence', body: 'His mother played a particularly influential role in shaping his character. Despite the challenges of raising nine children and times when food was scarce, she always found ways to provide for her family. Her strength, care and determination left a lasting impression on him, while his father also contributed to the values and discipline instilled in the household.' },
          { heading: 'Early Interests', body: 'During his younger years, Ps Carelse enjoyed playing soccer for a local club for several years, although he never pursued the sport professionally.' },
          { heading: 'Working Career', body: 'His working career began at TFG in 1990, where he remained employed for 36 years, serving until his retirement in 2026. Among his professional responsibilities, he worked as a watch technician for 13 years. His years in the workplace taught him valuable lessons about commitment, perseverance, responsibility and service.' },
        ],
      },
      {
        tab: 'Calling',
        content: [
          { heading: 'Spiritual Journey', body: 'Ps Carelse gave his life to Christ at approximately 16 years of age after his brother invited him to attend a youth meeting at a Christian Reformed Church. During that encounter, he experienced a profound moment of spiritual transformation. As someone prayed for him and led him to Christ, he found a sense of peace unlike anything he had experienced before. His brother\'s example and the guidance of fellow believers played an important role in nurturing his faith.' },
          { heading: 'Growing in Faith', body: 'Through the influence of those who taught him the Word of God and encouraged him to serve, he gradually became more involved in church life. Over the years, he served in various capacities including Sunday School, youth ministry and the church board. After joining the Church of the Nazarene, his pastor gave him opportunities to preach and affirmed the calling he believed God had placed upon his life.' },
          { heading: 'Confirmation of the Call', body: 'A significant moment occurred during a district assembly, where Reverend Carla Zanberg preached about the call to ministry. During the altar call, Ps Carelse responded and realised that his wife was standing alongside him. This experience strengthened his understanding that they were being called to serve God together. The Scripture in Daniel 3 became particularly meaningful during this season of his life.' },
          { heading: 'Path to Theological Studies', body: 'He recalls the practical challenges of pursuing theological studies while raising two children. Relocating to Johannesburg for training was not feasible for the family, but the opening of a local district Bible school at the Church of the Nazarene in Ottery provided an opportunity to pursue his calling closer to home. Although he initially expected his studies to take three years, the journey ultimately took four years. Through perseverance, faith and the support of his family, he completed his studies and continued preparing for ministry.' },
        ],
      },
      {
        tab: 'Education',
        content: [
          {
            heading: 'Qualifications',
            list: [
              'Theological studies — Local district Bible school, Church of the Nazarene, Ottery',
              'Local Ministerial Licence',
              'District Ministerial Licence',
            ],
          },
          { heading: 'Formation Beyond Studies', body: 'His preparation for ministry was not limited to formal studies. Years of serving in church leadership, working alongside other ministers and caring for congregants also contributed to his development as a pastor.' },
        ],
      },
      {
        tab: 'Ministry',
        content: [
          {
            heading: 'Roles Served',
            list: [
              'Elder — Christian Reformed Church (including leading the congregation for several months during the pastor\'s suspension)',
              'Youth Leader (1 year) — Bonteheuwel Church of the Nazarene',
              'Steward (several years) — Bonteheuwel Church of the Nazarene',
              'Head Steward (2 years) — Bonteheuwel Church of the Nazarene',
              'SDMI Leader — Bonteheuwel Church of the Nazarene',
              'Men\'s Ministry Leader (1 year) — Bonteheuwel Church of the Nazarene',
              'Senior Pastor — Restoration Church of the Nazarene, Heideveld (Current)',
            ],
          },
          { heading: 'Responsibilities', body: 'His responsibilities include preaching and teaching the Word of God, providing spiritual guidance, visiting congregants, supporting families and leading the congregation in its spiritual growth.' },
          { heading: 'Leadership During Transition', body: 'After completing his theological studies, he worked alongside fellow pastors and ministry students to maintain the life and activities of the Bonteheuwel congregation when its senior pastor left. Together, they helped ensure that the church\'s departments, ministry activities and finances continued to function.' },
          { heading: 'Key Milestones', body: 'Among the milestones he values are the growth of a cell group that encouraged people to attend church and become members, completing his theological studies while travelling from Bonteheuwel to Ottery several evenings a week, and helping sustain the Bonteheuwel congregation during a period of leadership transition.' },
          { heading: 'Community Impact', body: 'His ministry involvement included open-air services, community outreach and helping provide food to people in need. Through these initiatives, the church was able to reach individuals in the community, welcome people into its fellowship and encourage some to become members. For Ps Carelse, ministry extends beyond the church building — it involves reaching people where they are, responding to practical needs and creating opportunities for individuals to encounter the love of God.' },
        ],
      },
      {
        tab: 'Values',
        content: [
          {
            heading: 'Core Values',
            list: [
              'Equality and fairness',
              'Respect and dignity for every person',
              'Love and unity',
              'Transparency and honesty in leadership',
            ],
          },
          { heading: 'Leadership Philosophy', body: 'Ps Carelse believes that effective Christian leadership should be rooted in equality, fairness, respect, love and unity. He encourages people to uplift one another rather than look down on others. He values transparency and honesty, striving to keep the congregation informed and regularly consulting with the church board when addressing church matters and making decisions.' },
          { heading: 'Mentoring Approach', body: 'Mentorship is an important part of his leadership philosophy. Remembering the guidance he received throughout his own spiritual journey, he understands the importance of helping others grow in their faith, recognise their gifts and discover their calling. His approach reflects a desire to create an environment in which people feel respected, supported and encouraged to serve God according to their abilities.' },
          { heading: 'Family Life', body: 'Ps Carelse is married to Hortensia Bianca Aurelia Carelse, who also serves as a pastor and associate pastor at the church. At the time of the interview, they had been married for 26 years and were approaching their 27th wedding anniversary on 18 December. They are blessed with two children, Courtney Selena Carelse and Timothy Joshua Carelse. He values spending meaningful time with his wife and children, sometimes taking weekend getaways, switching off their phones and enjoying games, dominoes, jokes and conversation together.' },
          { heading: 'Work-Life Balance', body: 'He places strong emphasis on maintaining a healthy balance between ministry and family life. His guiding principle is: "God first, family second, church third." He wants his children to know that they can trust him, approach him freely and seek his help whenever they need it.' },
          { heading: 'Personal Interests', body: 'Outside ministry, Ps Carelse enjoys following Manchester United, watching rugby — particularly the Stormers and Springboks — and walking with his wife at Jack Muller Park. He also enjoys exercise and spending time with his family, including occasional walks along the beach and sharing snacks together.' },
        ],
      },
      {
        tab: 'Vision',
        content: [
          { heading: 'Vision for the Church', body: 'Ps Carelse envisions Restoration Church of the Nazarene as a safe and welcoming place where people can encounter God, grow spiritually and experience genuine Christian fellowship. His desire is to see God\'s people strengthened in their faith, restored in their joy and united as a spiritual family. He believes that the love members show one another should be a visible testimony of their relationship with Christ.' },
          {
            heading: 'Goals for the Next 2–3 Years',
            list: [
              'Establish and strengthen cell groups within surrounding neighbourhoods, with approximately five groups and a combined target of 60 people meeting on Wednesdays',
              'Revive evening services and renew the congregation\'s excitement, participation and productivity in church life',
              'Make ministry more accessible by reaching people in their own communities',
            ],
          },
          { heading: 'Life Scripture', body: 'Philippians 4:6–7 — "Do not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving, present your requests to God. And the peace of God, which transcends all understanding, will guard your hearts and your minds in Christ Jesus."' },
          { heading: 'Advice to Others', body: 'When people approach him for advice, he is mindful of the responsibility involved in guiding others. Rather than assuming he has every answer, he values listening, praying with people and reminding them that God remains in control.' },
          { heading: 'Legacy', body: 'Ps Carelse emphasises the importance of making a positive difference in people\'s lives. He wants people to remember not only what he did, but also how they felt in his presence and the encouragement they received through their interactions with him. His motto: "Live in the moment. Tomorrow is not a promise. Yesterday is history, but today is a present. Live in the moment."' },
          { heading: 'Fun Fact', body: 'Ps Carelse loves making people laugh. He enjoys joking and bringing joy to those around him, and people have even told him that he could have been a comedian. His sense of humour is an expression of his warm personality and his enjoyment of connecting with others.' },
        ],
      },
    ],
  },
  {
    id: "ruach-nazarene",
    name: "Ruach Church of the Nazarene",
    area: "Cape Town",
    pastor: "Jessica Swartz",
  },
  {
    id: "sirlowryspass-nazarene",
    name: "Sir Lowry's Pass Church of the Nazarene",
    area: "Somerset West",
    pastor: "Peter Louw",
    image: require('../assets/SirlowryspassCOTN.jpeg'),
  },
  {
    id: "steenberg-nazarene",
    name: "Steenberg Church of the Nazarene",
    area: "Steenberg",
    pastor: "Quinton Williams",
    image: require('../assets/SteenbergCOTN.jpeg'),
    pastorImage: require('../assets/SteenbergResources/SteenbergPastor.jpeg'),
  },
  {
    id: "strandfontein-nazarene",
    name: "Strandfontein Church of the Nazarene",
    area: "Strandfontein",
    pastor: "Reginald Subjee",
    address: "Cnr Reygersdal & Watussi Drive, Bay View, Cape Town, 7788",
    pastorImage: require('../assets/DS.jpeg'),
  },
  {
    id: "sunnyside-nazarene",
    name: "Sunnyside Church of the Nazarene",
    area: "Cape Town",
    pastor: "Rodger Chetty",
    image: require('../assets/SunnysideCOTN.jpeg'),
    address: "C/O Benbow and Bresee Avenue, Sunnyside, Athlone, 7764",
  },
  {
    id: "victory-nazarene",
    name: "Victory Church of the Nazarene",
    area: "Cape Town",
    pastor: "Rev. Liam Amansure",
    address: "127 Angela Street, Valhalla Park",
    image: require('../assets/Victory COTN.jpeg'),
    pastorImage: require('../assets/VictoryResources/VictoryPastor.jpeg'),
    pastorBio: "Rev. Liam Amansure currently serves as Lead Pastor of Victory Church of the Nazarene alongside his wife Sister Whitney and their daughters Makenzie and Keziah.",
    historyPeriods: [
      {
        period: '2006',
        title: 'Establishment',
        content: [
          'Victory Church of the Nazarene was established in 2006 by Pastor Martin, who at the time was serving as the pastor of Bonteheuwel Church of the Nazarene. Due to a large number of congregants living in Valhalla Park, many found it difficult and often unsafe to travel to Bonteheuwel for Sunday services.',
          'In response to this need, Pastor Martin initiated an outreach in Valhalla Park, beginning with a small splinter group and earlier Sunday services. These early gatherings were first held in the home of Sis Eunice Nitsky at 92 Simon Street, Valhalla Park.',
        ],
      },
      {
        period: 'Early Growth',
        title: 'Transition & Relocation',
        content: [
          'As the congregation grew, leadership transitioned to Pastor Chetty, under whose guidance services were moved to Nooitgedacht. When the hosts of that venue relocated, services were then held in a classroom at Valpark Primary School, secured by Pastor Chetty.',
          'Following Pastor Chetty\'s departure, Pastor Levi assumed leadership of Victory Church of the Nazarene. During this season, due to repeated break-ins at the school, the church board sought an alternative meeting place. Brother William and Sister Jacqueline Cornelius opened their home at 127 Angela Street, Valhalla Park, where the congregation continued to gather in worship.',
        ],
      },
      {
        period: '2018–2024',
        title: 'New Seasons of Leadership',
        content: [
          'Pastor Levi faithfully shepherded the church until his passing in 2018. After his passing, Pastor Nathan Valensky and his family joined the church as the pastoral family, serving from 2018 to 2024.',
          'Following his ministry, God graciously provided new leadership through Pastor Liam Amansure and his family — his wife Sister Whitney and their daughters Makenzie and Keziah — who currently serve and continue to lead Victory Church of the Nazarene.',
        ],
      },
    ],
  },
  {
    id: "wesbank-nazarene",
    name: "Wesbank Church of the Nazarene",
    area: "Cape Town",
    pastor: "Michael Cupido",
  },
  {
    id: "wellington-nazarene",
    name: "Wellington Church of the Nazarene",
    area: "Wellington",
    pastor: "Freddie Green",
    image: require('../assets/WellingtonCOTN.jpeg'),
  },
];
